package com.example.mystybag.login.model

import com.example.mystybag.core.model.CountryItem

enum class AddMolRequiredField {
    FIRST_NAME,
    LAST_NAME,
    DIAL_CODE,
    PHONE_NUMBER
}

data class AddMolUIState(
    val firstName: String = "",
    val lastName: String = "",
    val phoneNumber: String = "",
    val dialCode: String = "",
    val countries: List<CountryItem> = emptyList(),
    val showCountryPicker: Boolean = false,
    val requiredFieldErrors: Set<AddMolRequiredField> = emptySet(),
    val validationRequestId: Int = 0
)
